<template>
  <div>
    <div class="contentArea">
      <vs-row>
        <vs-col vs-lg="4" vs-sm="0" vs-xs="0"> </vs-col>
        <vs-col vs-lg="4" vs-sm="6" vs-xs="12" class="flex justify-center">
          <h6>ท่านกำลังเพิ่ม/แก้ไข้ข้อมูลในภาษา {{ radios2.toUpperCase() }}</h6>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
          <vs-row class="flex justify-end">
            <vs-radio
              v-for="(lang, index) in language"
              :key="index"
              v-model="radios2"
              class="px-3"
              :vs-value="lang.name"
              @change="changelang(index)"
              >{{ lang.name.toUpperCase() }}</vs-radio>
          </vs-row>
        </vs-col>
      </vs-row>

      <vs-row vs-w="12">
        <div class="fromstyle">
          <form v-on:submit.prevent="submitForm">
            <div class="flex justify-content-between">
              <label for="uploadbanner">รูป banner</label>
              <vs-icon type="button" icon="delete" size="small" color="#072C49" @click="deleteImg(radios2)" ></vs-icon> 
            </div>
            
            <div v-if="banner.img" class="flex justify-content-center">
            <img
              :src="banner.img"
              v-if="showimage"
              @click="clickimage"
              class="bannerimage"
            />
            <vs-upload
              v-else
              limit="1"
              id="uploadbanner"
              automatic
              @on-success="successUpload"
            />
            </div>
            <div v-else>
              <vs-upload
              limit="1"
              id="uploadbanner"
              automatic
              @on-success="successUpload"
            />
            </div>
            <br />
            <label for="header">หัวข้อ</label>
            <vs-input
              class="headerbanner"
              id="header"
              placeholder="Open ceremony"
              v-model="banner.title"
            />
            <br />
            <label for="header">ลิ้งค์ url</label>
            <vs-input
              class="headerbanner"
              id="header"
              placeholder="Cp Innovation Exposition 2021"
              v-model="banner.url"
            />
            <br />

            <il class="radiobanner" >
              <il>
                <vs-radio class="radioitem" vs-name="radios1" vs-value="share" v-model="publishRadio"
                   >เผยแพร่</vs-radio
                >
              </il>
              <il>
                <vs-radio vs-name="radios1" vs-value="on_schedule" v-model="publishRadio"
                  >ตั้งเวลาเผยแพร่</vs-radio
                >
              </il>
            </il>
            <br />
            <vs-row vs-w="12">
              <vs-col
                vs-offset="0"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
                vs-lg="5"
                vs-sm="5"
                vs-xs="12"
              >
                <label>เริ่ม</label>
                <div class="fixtimepicker">
                  <v-date-picker
                    v-model="date_start"
                    :masks="{ input: ['DD/MM/YY'] }"
                  >
                    <template v-slot="{ inputValue, inputEvents }">
                      <input
                        class="bg-white border px-2 py-1 rounded timepicker"
                        style="width"
                        :value="inputValue"
                        v-on="inputEvents"
                      />
                    </template>
                  </v-date-picker>
                </div>

                <vs-select class="selecthour" v-model="selecthour_start">
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in options1"
                  />
                </vs-select>
                <vs-select class="selectmin" v-model="selectmin_start">
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in options2"
                  />
                </vs-select>
              </vs-col>

              <vs-col
                vs-offset="0"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
                vs-lg="6"
                vs-sm="6"
                vs-xs="12"
              >
                <label>ถึง</label>
                <v-date-picker
                  v-model="date_end"
                  :masks="{ input: ['DD/MM/YY'] }"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="bg-white border px-2 py-1 rounded timepicker"
                      style="width"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
                <vs-select class="selecthour" v-model="selecthour_end">
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in options1"
                  />
                </vs-select>
                <vs-select class="selectmin" v-model="selectmin_end">
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in options2"
                  />
                </vs-select>
              </vs-col>
            </vs-row>
            <vs-row vs-w="12">
               <vs-col vs-w="12" class="flex justify-end">
                  <button class="share-btn" :@click="summitForm">เผยแพร่</button>
              </vs-col>
            </vs-row>
          </form>
        </div>

        <!-- <vs-col vs-offset="10" vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
      </vs-col> -->
      </vs-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  methods: {
    changelang(index) {
      // console.log(index)
      this.$store.dispatch("general/switch_language", index);
      this.$store.dispatch("general/get_banner");
    },
    clickimage() {
      this.showimage = !this.showimage;
      
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Lorem ipsum dolor sit amet, consectetur",
      });
    },
    submitForm(e) {
      console.log(e);
    },
    deleteImg(i) {
      this.$store.dispatch("general/delete_img",this.radios2)
      
    }
  },

  async mounted() {
    await this.$store.dispatch("general/get_language");
    await this.$store.dispatch("general/get_banner");
    // console.log(this.date_test)

    console.log("banner", this.start_end);
    this.radios2 = this.language.filter((a) => a.value)[0].name;
    this.date_start = this.start_end.startDate;
    this.date_end = this.start_end.endDate;
    this.selecthour_start = moment(this.start_end.startDate).format("HH")
    this.selecthour_end= moment(this.start_end.endDate).format("HH")
    this.selectmin_start = moment(this.start_end.startDate).format("mm")
    this.selectmin_end = moment(this.start_end.endDate).format("mm")
    this.publishRadio = this.isPublish
    },
  data() {
    return {
      uploadpic: null,
      radio: null,
      showimage: true,
      headerbanner: null,
      selecthour_start: null,
      selecthour_end: null,
  
      options1: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
      ],
      selectmin_start: "null",
      selectmin_end: "null",
      options2: ["00", "30"],
      date_start: new Date(),
      date_end: new Date(),
      radios2: "primary",
      publishRadio:null
    };
  },
  computed: {
    ...mapGetters({
      banner: "general/banner",
      language: "general/language",
      start_end: "general/start_end",
      isPublish:"general/isPublish"
    }),
  },
};
</script>

<style lang="scss" scoped>
.contentArea {
  border-style: solid;
  border-width: 2px;
  border-color: rgb(92, 92, 92);
  padding: 30px 20px;
  
  margin-top:100px;
  justify-content: center;
  border-radius: 5px;
}
.uploadbanner {
  border: red;
  height: 100px;
}
.fromstyle {
  width: 100%;
}
.headerbanner {
  width: 100%;
}
.share-btn {
  background-color: gray;
  padding: 5px 40px 5px 40px;
  border-radius: 10px;
  border-style: none;
  color: #ffff;
}
.share-btn:hover {
  transition-delay: 100ms;
  background-color: #072C49;
}
.share-btn:active {
  background-color: #072C49;
}
.timepicker {
  width: 100px;
  height: 43px;
  margin: 10px;
  border-radius: 5px;
}
.selecthour {
  width: 65px;
  margin: 5px;
}
.selectmin {
  width: 65px;
  margin: 5px;
}
.radiobanner {
  display: flex;
  justify-content: flex-start;
}
.radioitem {
  margin-right: 10px;
}
.fixtimepicker {
  z-index: 99;
}
.bannerimage {
  height: 250px;
  max-width: 100%;
}
</style>
